export const mapTables = (tempDiv) => {
	const getTables = tempDiv.querySelectorAll('.table-input');

	if (getTables?.length > 0) {
		for (const getTab of getTables) {
			const parentEl = getTab.parentElement;
			const thead = getTab.querySelectorAll('thead');

			for (const head of thead) {
				const theads = head.querySelectorAll('th');
				for (const el of theads) {
					el.style.backgroundColor ||= '#F2F2F2';
				}
			}

			if (parentEl.tagName.toLowerCase() === 'figure') {
				parentEl.removeAttribute('class');
				parentEl.setAttribute('class', 'table');
				parentEl.innerHTML = '';
				parentEl.append(getTab);
				// Removing resisers from table
				const resiser = parentEl.querySelectorAll('.ck-table-column-resizer');
				resiser?.length > 0 && resiser?.forEach((item) => item?.remove());
			}
		}
	}
};
